export const DRIVER_PORTAL_URL = "https://driver.stargaterentals.com"
